import { Component, ContentChildren, QueryList, AfterContentInit, Input } from '@angular/core';
import { TabItemComponent } from '../tab-item/tab-item.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'nav-tab-standalone',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tab-standalone.component.html',
  styleUrls: ['./tab-standalone.component.scss']
})
export class TabStandaloneComponent implements AfterContentInit {
  @ContentChildren(TabItemComponent) tabItems!: QueryList<TabItemComponent>;
  activeTabIndex: number = 0;

  @Input() header?: string;
  @Input() whiteTabColor?: boolean = false;

  ngAfterContentInit() {
    // Optionally, set activeTabIndex to 0 or keep as is
  }

  selectTab(index: number) {
    this.activeTabIndex = index;
  }
}
